import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { IndexTitle } from '@buyside/components/presentation/IndexPage/IndexPage';
import LoadingSpinner from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';
import NewMessageForm from '@buyside/components/presentation/MessagesIndexPage/NewMessageForm/NewMessageForm';

import {
  CreateMessageMutationResult,
  useAssociateViewerIntroRequestMessageMutation,
  useCreateMessageMutation,
  useMainNavigationCurrentUserQuery
} from '@interfaces/graphql-typings';

const NewMessageFormPage: React.FC = () => {
  const navigate = useNavigate();
  const { encodedPayload } = useParams<{ encodedPayload?: string }>();

  const { data, loading } = useMainNavigationCurrentUserQuery();

  const [associateViewerIntroMutation] = useAssociateViewerIntroRequestMessageMutation();
  const [createMessage] = useCreateMessageMutation();

  if (loading) return <LoadingSpinner />;
  if (!data?.currentUser?.canManageMessages) return <Navigate to="/inbox" />;

  let toUserId = null;
  let userInfo = null;
  let introId = null;

  if (encodedPayload) {
    const payload = JSON.parse(window.atob(encodedPayload));

    toUserId = payload.id;
    userInfo = payload.info;
    introId = payload.virId;
  }

  const afterSubmit = (result: CreateMessageMutationResult): void => {
    const sentMessageId = result.data?.createMessage?.id;
    if (!sentMessageId) return;

    if (introId) {
      associateViewerIntroMutation({
        variables: {
          messageId: sentMessageId,
          viewerIntroRequestId: introId
        }
      })
        .then(() => navigate(`/${sentMessageId}`))
        .catch(error => {
          throw error;
        });
    } else {
      navigate(`/${sentMessageId}`);
    }
  };

  return (
    <>
      <IndexTitle>New Message</IndexTitle>
      <NewMessageForm
        afterSubmit={afterSubmit}
        createMessage={createMessage}
        toUserId={toUserId}
        userInfo={userInfo}
      />
    </>
  );
};

export default NewMessageFormPage;
